import { colorsSystem } from '@common/util/defaultValues';

class UteisHistologia {

    static getInicialKanbam() {
        let lista = [];

        lista.push({
            'blocos': [],
            'title': {
                text: 'Blocos',
                color: colorsSystem.DG1
            }
        });

        lista.push({
            'pendente': [],
            'title': {
                text: 'Lâminas pendentes',
                color: colorsSystem.DG2
            }
        });

        lista.push({
            'executando': [],
            'title': {
                text: 'Lâminas em andamento',
                color: colorsSystem.DG3
            }
        });

        lista.push({
            'laminas': [],
            'title': {
                text: 'Lâminas prontas',
                color: colorsSystem.DG5
            }
        });
        return lista;
    }

    static getInicialLaminas() {
        return [
            {
                lamina: 'Sentinela Mama',
                qtd: null
            },
            {
                lamina: 'Sentinela Melanoma',
                qtd: null
            },
            {
                lamina: 'Col. Especial',
                qtd: null
            },
            {
                lamina: 'Imuno',
                qtd: null
            },
            {
                lamina: 'Recorte',
                qtd: null
            },
            {
                lamina: 'Fish',
                qtd: null
            },
            {
                lamina: 'Cish',
                qtd: null
            }
        ]
    }
    static getTipoLamina(tipoBloco, intl) {
        const enumTipo = {
            AUTOPSIA: {
                nome: `${ intl.formatMessage({id:"dashboards.histology.autopsy"}) }`,
                qtd: null
            },
            SVO: {
                nome: 'Svo',
                qtd: null
            },
            BIOPSIA: {
                nome: `${ intl.formatMessage({id:"dashboards.histology.biopsy"}) }`,
                qtd: null
            },
            PECA: {
                nome: `${ intl.formatMessage({id:"dashboards.histology.piece"}) }`,
                qtd: null
            },
            PUNCAO: {
                nome: `HE ${ intl.formatMessage({id:"dashboards.histology.puncture"}) }`,
                qtd: null
            },
            CITOLOGIA: {
                nome: `HE ${ intl.formatMessage({id:"dashboards.cytology.cytology"}) }`,
                qtd: null
            },
            CONGELACAO: {
                nome: `${ intl.formatMessage({id:"dashboards.examDetail.freezing"}) }`,
                qtd: null
            },
            REVISAO: {
                nome: `${ intl.formatMessage({id:"dashboards.examDetails.status.revision"}) }`,
                qtd: null
            }
        }


        var text = tipoBloco.toLowerCase();
        text = text.replace(new RegExp('[ÁÀÂÃ]', 'gi'), 'a');
        text = text.replace(new RegExp('[ÉÈÊ]', 'gi'), 'e');
        text = text.replace(new RegExp('[ÍÌÎ]', 'gi'), 'i');
        text = text.replace(new RegExp('[ÓÒÔÕ]', 'gi'), 'o');
        text = text.replace(new RegExp('[ÚÙÛ]', 'gi'), 'u');
        text = text.replace(new RegExp('[Ç]', 'gi'), 'c');
        text = text.replace('ç', 'c');
        text = text.replace(' ', '');
        var nome = text.toUpperCase();
        return enumTipo[nome];
    }
}
export default UteisHistologia;




// WEBPACK FOOTER //
// ./src/pages/histologia/laminas/laminas.util.js